import React, { useEffect, useState } from 'react'
import { Modal } from '../../../components/modal/Modal'
import { classNameInput, enviarImagenMinio, notify } from '../../../../utils/utils'
import { toast } from 'react-toastify'

const FilaForm = ({mostrar= true,label,children}) => {
	if(!mostrar) return null

	return(
		<>
			<span>{label}</span>
			<span>:</span>
			<div>{children}</div>
		</>
	)
}

const ModalRegistroEdicion = ({
	hookRepuestos,
	isOpenRepuestos,
	closeModalRepuestos,
	fotoDefault,
	inputFoto,
	modificarImagen,
	Tabs,
	menusModalEnviado,
	funcionListarTabla
}) => {
	const [esTipoServicio, setEsTipoServicio] = useState(false)

	useEffect(() => {
		setEsTipoServicio(hookRepuestos.repuesto.codRepuestoTipo == 2)
	},[hookRepuestos.repuesto.codRepuestoTipo])

	const funcionRegistrarEditar = async () => {
		const importoFoto = inputFoto.current.files.length != 0
		const urlVer = importoFoto 
		? await enviarImagenMinio({
			nombreCarpeta: "tgps",
			nombreArchivo: `%2Ffotos-personas%2Frepuesto-${hookRepuestos.repuesto.codigoInterno}`,
			file: inputFoto.current.files[0],
		}) : ''
		
		const jsonData = await hookRepuestos.resgistrarEditarRepuesto(urlVer)
		notify(jsonData.DesResultado,jsonData.CodResultado == 1 ? 'success' : 'error')

		if(jsonData.CodResultado == 1){
			closeModalRepuestos()
			await funcionListarTabla()
		}
	}

	

  	return (
		<Modal	 
			isOpen={isOpenRepuestos} 
			closeModal={closeModalRepuestos} 
			action={funcionRegistrarEditar}
			title={hookRepuestos.repuesto.codRepuesto ? 'Editar' : 'Registrar'}
		>
			<div className='flex flex-col gap-4 px-4 py-3'>
				<div className="flex gap-4 items-center flex-wrap justify-center">
					<div className="w-[500px] grid grid-cols-[auto_auto_1fr] gap-x-3 gap-y-2 items-center">
						<FilaForm label={"Código fabrica"} mostrar={!esTipoServicio} >
							<input 
								value={hookRepuestos.repuesto.codigoBarra} 
								onChange={(e) => {hookRepuestos.editarValorRepuesto('codigoBarra',e.target.value)}} 
								className={`${classNameInput} caret-input`}
							/>
						</FilaForm>

						<FilaForm label={"Tipo"}>
							<select 
								value={hookRepuestos.repuesto.codRepuestoTipo} 
								onChange={(e) => {hookRepuestos.editarValorRepuesto('codRepuestoTipo',e.target.value)}} 
								disabled={hookRepuestos.repuesto.codRepuesto ? true : false} 
								className={`${classNameInput} caret-input`}
							>
								<option value={0}>--Seleccione--</option>
								{hookRepuestos.listaArticulos.map((data,i) => <option key={i+1} value={data.codRepuestoTipo}>{data.nomRepuestoTipo}</option>)}
							</select>
						</FilaForm>

						<FilaForm label={"Tipo de sistema"}>
							<div className="items-center gap-4 grid grid-cols-[1fr_auto_auto]">
								<select 
									value={hookRepuestos.repuesto.codRepuestoSistema} 
									onChange={(e) => {
										hookRepuestos.editarValorRepuesto('codRepuestoSistema',e.target.value)
										hookRepuestos.obtenerCodigoRepuestoActual(e.target.value)
									}} 
									disabled={hookRepuestos.repuesto.codRepuesto ? true : false} 
									className={`${classNameInput} caret-input`}
								>
									<option value={0}>--Seleccione--</option>
									{hookRepuestos.tipoSistemas.map((data,i) => <option key={i+1} value={data.codRepuestoSistema}>{data.nomRepuestoSistema}</option>)}
								</select>
								<span title='Codigo interno'>C.Interno: </span>
								<div className="flex items-center gap-4">
									<span className='text-center w-full'>{hookRepuestos.repuesto.codigoInterno || '-'}</span>
								</div>
							</div>
						</FilaForm>

						<FilaForm label={"Nombre comercial"}>
							<input value={hookRepuestos.repuesto.nombreRepuesto} onChange={(e) => {hookRepuestos.editarValorRepuesto('nombreRepuesto',e.target.value)}} className={`${classNameInput} caret-input`}/>
						</FilaForm>

						<FilaForm label={"Marca"} mostrar={!esTipoServicio}>
							<input value={hookRepuestos.repuesto.marca} onChange={(e) => {hookRepuestos.editarValorRepuesto('marca',e.target.value)}} className={`${classNameInput} caret-input`}/>
						</FilaForm>

						<FilaForm label={"Unidad de medida"}>
							<select value={hookRepuestos.repuesto.codRepuestoUM} onChange={(e) => {hookRepuestos.editarValorRepuesto('codRepuestoUM',e.target.value)}} className={`${classNameInput} caret-input`}>
								<option value={0}>--Seleccione--</option>
								{hookRepuestos.unidadesMedida.map((data,i) => <option key={i+1} value={data.codRepuestoUM}>{data.nomRepuestoUM}</option>)}
							</select>
						</FilaForm>
						
						<FilaForm label={"Garantía"} mostrar={!esTipoServicio}>
							<input value={hookRepuestos.repuesto.garantia} onChange={(e) => {hookRepuestos.editarValorRepuesto('garantia',e.target.value)}} className={`${classNameInput} caret-input`} />
						</FilaForm>
						
						<FilaForm label={"Características técnicas"} mostrar={!esTipoServicio}>
							<textarea value={hookRepuestos.repuesto.caracteristicas} onChange={(e) => {hookRepuestos.editarValorRepuesto('caracteristicas',e.target.value)}} className={`${classNameInput} caret-input py-1`}/>
						</FilaForm>

						<FilaForm label={"Tiene serie"} mostrar={!esTipoServicio}>
							<div className='flex gap-4'>
								<div className='flex items-center gap-2'>
									<input 
										checked={!hookRepuestos.repuesto.registraSerie} 
										className='cursor-pointer' id="inputNoSerie" type="radio" name='Serie' value={false} 
										onChange={e => {
											hookRepuestos.editarValorRepuesto('registraSerie',!e.target.checked)
											if(hookRepuestos.repuesto.afectaNeumatico){
												hookRepuestos.editarValorRepuesto('afectaNeumatico',!e.target.checked)
												notify("Se desactivó este producto para gestión de neumático", "info")
											}
										}}
									/>
									<label className='cursor-pointer' htmlFor="inputNoSerie">No</label>
								</div>

								<div className='flex items-center gap-2'>
									<input 
										checked={hookRepuestos.repuesto.registraSerie} 
										className='cursor-pointer' id="inputSiSerie" type="radio" name='Serie' value={true} 
										onChange={e => {
											hookRepuestos.editarValorRepuesto('registraSerie',e.target.checked)
										}}
									/>
									<label className='cursor-pointer' htmlFor="inputSiSerie">Si</label>
								</div>
							</div>
						</FilaForm>

						<FilaForm label={"Neumático gestión"} mostrar={!esTipoServicio}>
							<div className='flex gap-4'>
								<div className='flex items-center gap-2'>
									<input 
										checked={!hookRepuestos.repuesto.afectaNeumatico} 
										className='cursor-pointer' id="inputNoNeumatico" type="radio" name='Neumatico' value={false} 
										onChange={e => {
											hookRepuestos.editarValorRepuesto('afectaNeumatico',!e.target.checked);
										}}
									/>
									<label className='cursor-pointer' htmlFor="inputNoNeumatico">No</label>
								</div>

								<div className='flex items-center gap-2'>
									<input 
										checked={hookRepuestos.repuesto.afectaNeumatico} 
										className='cursor-pointer' id="inputSiNeumatico" type="radio" name='Neumatico' value={true} 
										onChange={e => {
											if(hookRepuestos.repuesto.registraSerie){
												hookRepuestos.editarValorRepuesto('afectaNeumatico',e.target.checked);
											}else{
												notify("Para que este producto se gestione como neumático se tiene que activar la serie", "error")
											}
										}}
									/>
									<label className='cursor-pointer' htmlFor="inputSiNeumatico">Si</label>
								</div>
							</div>
						</FilaForm>
					</div>
					
					<div className="text-center flex flex-col items-center justify-center gap-5">
						<div>
							<img className='rounded-xl border w-[200px] h-[200px] mb-1 lg:w-[150px] lg:h-[150px]' src={hookRepuestos.repuesto.urlImagen || fotoDefault} alt='' />
							<input ref={inputFoto} 
								onChange={e => {modificarImagen(e)}} 
								type="file" 
								name="file-1" 
								id="file-1" 
								className="inputfile inputfile-1" 
								accept='.jpg,.png' 
							/>
							<label htmlFor="file-1">
								<i className="fa fa-image"></i> 
								<span className=""> Seleccione</span>
							</label>
						</div>
						
					</div>
				</div>
				
				<div className='max-w-full'>
					<Tabs 
						contenidos = {
							[0,1].includes(Number(hookRepuestos.repuesto.codRepuestoTipo)) 
							? menusModalEnviado() 
							: menusModalEnviado().filter(data => data.nombreMenu != 'Durabilidad')
						}
					/>
				</div>
			</div>
		</Modal>
  	)
}

export default ModalRegistroEdicion